import React from "react";
import styles from "./styles/Footer.module.css";
import logo from "../assets/images/footer_logo.png";
import { useLanguage } from "../LanguageContext";

function Footer({appLinks}) {
    const { t } = useLanguage();

    return (
        <footer className={styles.footer}>
            <div className={styles.top}>
                <div className={styles.left}>
                    <h1>
                        {t("footer.description_start")} <span>Idleasing</span>
                        {t("footer.description_end")}
                    </h1>
                    <p>
                        {t("footer.moreInfo")}{" "}
                        <a href="https://www.idleasing.am" target="_blank" rel="noreferrer">
                            www.idleasing.am
                        </a>
                    </p>
                    <a href="https://www.idleasing.am" className={styles.button}>
                        {t("footer.goToSite")}
                    </a>
                </div>
                <div className={styles.right}>
                    <ul>
                        <li>
                            <a href="/#advantages">{t("footer.advantages")}</a>
                        </li>
                        <li>
                            <a href="/#about">{t("footer.about")}</a>
                        </li>
                        <li>
                            <a href="/#terms">{t("footer.terms")}</a>
                        </li>
                        <li>
                            <a href="/#calculator">{t("footer.calculator")}</a>
                        </li>
                        <li>
                            <a href="/#faq">{t("footer.faq")}</a>
                        </li>
                        <li>
                            <a href="https://idleasing.am/ypepftcbdncc/pustayastranitsa_fsec/">{t("footer.useful_links")}</a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="tel:+37412777077"> +374 12 77 70 77</a>
                        </li>
                        <li>
                            <a href="mailto:info@idleasing.am">info@idleasing.am</a>
                        </li>

                        <div className={styles.mobileShow}>
                            <li>
                                <a href={appLinks[3].url}>Facebook</a>
                            </li>
                            <li>
                                <a href={appLinks[4].url}>LinkedIn</a>
                            </li>
                            {appLinks[5].url !== '' && (
                                <li>
                                    <a href={appLinks[5].url}>Instagram</a>
                                </li>
                            )}
                        </div>
                    </ul>
                    <ul className={styles.mobileHide}>
                        <li>
                            <a href={appLinks[3].url}>Facebook</a>
                        </li>
                        <li>
                            <a href={appLinks[4].url}>LinkedIn</a>
                        </li>
                        {appLinks[5].url !== '' && (
                            <li>
                                <a href={appLinks[5].url}>Instagram</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            <div className={styles.bottom}>
                <div className={styles.logo}>
                    <img src={logo} alt="Cosmocredit" />
                </div>
                <div className={styles.copy}>
                    <p>
                        <span>{t("footer.lastUpdate")}</span>
                        <br/>
                        <span dangerouslySetInnerHTML={{ __html: t("footer.attention") }}></span>
                    </p>
                    <p>
                        © {new Date().getFullYear()} CosmoCredit {t("footer.rights")}{" "}
                        <a href="https://garoon.design/" target="_blank" rel="noreferrer">
                            GSCA
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;